// extracted by mini-css-extract-plugin
module.exports = {"weapon":"WeaponContainer_weapon__2oM-n","parallax":"WeaponContainer_parallax__PoSId"};